const Features = {
  VARIANT_PRICE: 'variantPrice',
  DOWNLOADS: 'downloads',
  CUSTOMIZE_CONFIRMATION: 'customizeConfirmation',
  CUSTOMIZE_EMAIL_CONFIRMATION: 'customizeEmailConfirmation',
  SUBSCRIPTIONS: 'subscriptions',
  ZAPIER: 'zapierIntegration',
  REWARDFUL: 'rewardfulIntegration',
  PAYMENT_PLAN: 'paymentPlan',
  SUBSCRIPTION_START_DATE: 'subscriptionStartDate',
  SETUP_FEE: 'setupFee',
  DISCOUNTED_FROM_PRICE: 'discountedFromPrice',
  AG_PAY: 'agPay',
  MULTIPLE_PAYMENT_METHODS: 'multiplePaymentMethods',
  CUSTOM_CSS: 'customCss',
  CHECKOUT_PAGE_BADGE: 'checkoutPageBadge',
  LICENSE_KEYS: 'licenseKeys',
  BULK_DISCOUNTS: 'bulkDiscounts',
  PAY_WHAT_YOU_WANT_PRICING: 'payWhatYouWantPricing',
  NOTIFY_EMAIL: 'notifyEmail',
  WEBSITE_URL: 'websiteUrl',
  CUSTOM_DOMAIN: 'customDomain',
  EMAIL_DOMAIN: 'emailDomain',
  SEATS: 'seats',
  MULTI_STEP_CHECKOUT: 'multiStepCheckout',
  REDIRECT_TO_URL: 'redirectAfterPayment',
  HIDE_FIELDS: 'hideFields',
  EXPORTS: 'exports',
  DYNAMIC_PRICING: 'dynamicPricing',
  VARIANT_SHOW_HIDE_LOGIC: 'variantShowHideLogic',
  WEBHOOKS: 'webhooks',
  GOOGLE_SHEETS: 'googleSheets',
  SLACK: 'slack',
  ONE_CLICK_UPSELLS: 'oneClickUpsells',
  CUSTOM_FEES: 'customFees',
  MANUAL_PAYMENTS: 'manualPayments',
};

export default Features;
